import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const CertificateCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  width: 100%;
  overflow: hidden;
`;

export const CertificateHeader = styled.div`
  background: linear-gradient(90deg, #1e88e5 0%, #1976d2 100%);
  color: white;
  padding: 2rem;
  text-align: center;

  h1 {
    margin: 0 0 1rem 0;
    font-size: 2rem;
    font-weight: bold;
  }
`;

export const ValidationStatus = styled.div`
  display: flex;
  justify-content: center;
`;

export const ValidBadge = styled.span`
  background: #4caf50;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-weight: bold;
  font-size: 0.9rem;
`;

export const InvalidBadge = styled.span`
  background: #f44336;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-weight: bold;
  font-size: 0.9rem;
`;

export const CertificateBody = styled.div`
  padding: 2rem;
`;

export const CertificateInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;

  .info-group {
    display: flex;
    flex-direction: column;

    label {
      font-weight: bold;
      color: #495057;
      margin-bottom: 0.25rem;
      font-size: 0.9rem;
    }

    span {
      color: #212529;
      font-size: 1rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const UserInfo = styled.div`
  margin-bottom: 2rem;

  h3 {
    color: #1976d2;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  .info-group {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
      border-bottom: none;
    }

    label {
      font-weight: 600;
      color: #495057;
      min-width: 120px;
    }

    span {
      color: #212529;
      text-align: right;
      flex: 1;
    }
  }
`;

export const CourseInfo = styled.div`
  h3 {
    color: #1976d2;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  .info-group {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
      border-bottom: none;
    }

    label {
      font-weight: 600;
      color: #495057;
      min-width: 120px;
    }

    span {
      color: #212529;
      text-align: right;
      flex: 1;
    }
  }
`;

export const CertificateFooter = styled.div`
  background: #f8f9fa;
  padding: 2rem;
  text-align: center;
  border-top: 1px solid #e9ecef;

  p {
    margin: 0 0 1.5rem 0;
    color: #6c757d;
    line-height: 1.6;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  color: white;

  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-top: 5px solid white;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    margin: 0 auto 1rem;
  }

  p {
    font-size: 1.2rem;
  }
`;

export const ErrorContainer = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;

  h2 {
    color: #dc3545;
    margin-bottom: 1rem;
  }

  p {
    color: #6c757d;
    margin-bottom: 2rem;
    line-height: 1.6;
  }
`;

export const BackButton = styled.button`
  background: #1976d2;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1565c0;
  }
`;
